// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"fe510d64","284":"b663639e","349":"2080a679","499":"0fff1198","706":"4d13e1ea","839":"f389190f","841":"b4dc7423","952":"a0eb9198"}[chunkId] + ".chunk.js";
};